import { Component, Inject, OnInit } from '@angular/core';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';
import { DecipherService } from '../../services/decipher/decipher.service';
import { DecipherLocaleMarkers } from '../../interfaces/decipher.interface';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { notifyMessage } from '../../constants/notify-message';
import { AuthService } from '../../services/auth/auth.service';
import { MissingMarkerModalData } from '../../interfaces/missing-marker-modal.interface';

@Component({
  selector: 'ps-ui-missing-markers-modal',
  templateUrl: './missing-markers-modal.component.html',
  styleUrls: ['./missing-markers-modal.component.css'],
})
export class MissingMarkersModalComponent implements OnInit {
  hasMissingMarkers: boolean = false;
  psSurveyId: number = this._modalData.psSurveyId;
  decipherSurveyPath: string = this._modalData.decipherSurveyPath;
  displayLocales: string[] | null = this._modalData.displayLocales;
  missingMarkers: DecipherLocaleMarkers[] = [];
  isSurveyCreated: boolean = this._modalData.isCreated;

  constructor(
    private _decipherService: DecipherService,
    private _toastr: ToasterService,
    private _auth: AuthService,
    @Inject(ModalData)
    private _modalData: MissingMarkerModalData,
    private _modalRef: ModalRef<
      MissingMarkersModalComponent,
      {
        continue: boolean;
      }
    >
  ) {
    if (this._modalData.auth) {
      this._auth.setState(this._modalData.auth);
    }
    this._modalRef.resize('lg');
  }

  ngOnInit(): void {
    this._getSurveyMarkers();
  }

  private _getSurveyMarkers(): void {
    this._decipherService
      .getDecipherMarkers(this.decipherSurveyPath, this.psSurveyId)
      .subscribe(
        (response) => {
          this._checkMissingMarkersExist(response.data);
        },
        (error) => {
          this._toastr.warning(
            notifyMessage.warningMessage.DECIPHER.FETCH_MISSING_MARKER_FAILED
          );
          this.close(false);
        }
      );
  }

  private _checkMissingMarkersExist(localeMarkers: DecipherLocaleMarkers[]) {
    const localesWithMissingMarkers =
      this._returnMissingMarkerLocales(localeMarkers);
    if (localesWithMissingMarkers.length) {
      this.hasMissingMarkers = true;
      this.missingMarkers = localesWithMissingMarkers;
    } else {
      this.close(true);
    }
  }

  private _returnMissingMarkerLocales(localeMarkers: DecipherLocaleMarkers[]) {
    return localeMarkers.filter((localeMarkerObj) => {
      const { locale, missingMarkers = [] } = localeMarkerObj;
      return missingMarkers.length && this._shouldDisplayLocale(locale);
    });
  }

  private _shouldDisplayLocale(locale: string) {
    return (
      !Array.isArray(this.displayLocales) ||
      this.displayLocales.includes(locale)
    );
  }

  close(canContinue: boolean): void {
    this._modalRef.close({ continue: canContinue });
  }
}
